export default __webpack_public_path__ + "static/media/sd-slider-spcl-1.8a79b6d5.jpg";